import { Flex, Heading, Text, useAuthenticator } from "@aws-amplify/ui-react";
import { HealthInsights } from "../../ui-components";
import { useNavigate } from "react-router-dom";
import TodoContainer from "./todoContainer/TodoContainer";
import AppointmentContainer from "./appointmentContainer/AppointmentContainer";
import SymptomsGraphContainer from "./symptomsHistoryGraphContainer/SymptomsGraphContainer";
import FoodJournalsContainer from "./foodJournalsContainer/FoodJournalsContainer";
import { useAuth } from "../../ui-components/utils";
import { useUserQuery } from "../common/useUserQuery";
import MentalHealthContainer from "./mentalHealthContainer/MentalHealthContainer";

const HealthInsightsPage = () => {
  const navigate = useNavigate();
  const authAttributes = useAuth().user?.attributes ?? {};
  const { data: activeProfile } = useUserQuery();

  return (
    <Flex direction="column" padding="15px">
      <Flex direction={"column"}>
        <Text fontSize={{ base: "1.5em", small: "2em" }}>
          Welcome back {authAttributes["given_name"]}!
        </Text>

        {activeProfile?.isAdvocating === true && (
          <Text fontWeight={500}>
            You are advocating for{" "}
            {activeProfile?.nickname
              ? `${activeProfile?.givenName} (${activeProfile?.nickname})`
              : activeProfile?.givenName}
          </Text>
        )}
      </Flex>
      <Flex direction={"column"}>
        <MentalHealthContainer />
      </Flex>

      <Flex direction={{base:"column", medium:"row"}}>
        <TodoContainer />
        <AppointmentContainer />
      </Flex>
      <Flex>
        <FoodJournalsContainer />
      </Flex>
      <Flex style={{ minWidth: "100%" }}>
        <SymptomsGraphContainer style={{ minWidth: "100%" }} />
      </Flex>
    </Flex>
  );
};

export default HealthInsightsPage;
